<template>
  <div>
    <a-card :bordered="false">
      <a-form layout="inline" :form="form" @submit="handleSearch" style="margin-bottom: 16px">
        <a-form-item label="账期月">
          <a-input
            v-decorator="['carrier_month']"
            placeholder="yyyyMM"
            style="width: 120px"
            allow-clear
          />
        </a-form-item>
        <a-form-item label="ICCID">
          <a-input v-decorator="['iccid']" allow-clear style="width: 200px" />
        </a-form-item>
        <a-form-item label="来源">
          <a-select v-decorator="['source']" allow-clear style="width: 140px">
            <a-select-option value="monthly_job">月度批跑</a-select-option>
            <a-select-option value="purchase">采购入账</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" html-type="submit">查询</a-button>
          <a-button
            v-if="isShowMenu('sim_card_month_costs/rerun')"
            style="margin-left: 8px"
            @click="handleRerun"
          >重跑上月</a-button>
        </a-form-item>
      </a-form>

      <a-table
        :columns="columns"
        :data-source="tableData"
        :loading="loading"
        :pagination="pagination"
        row-key="id"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="showDetail(record)">明细</a>
        </span>
      </a-table>
    </a-card>

    <a-modal
      title="成本分项明细"
      :visible="detailVisible"
      :footer="null"
      width="720px"
      @cancel="detailVisible = false"
    >
      <a-descriptions bordered size="small" :column="2" style="margin-bottom: 16px">
        <a-descriptions-item label="ICCID">{{ detail.iccid }}</a-descriptions-item>
        <a-descriptions-item label="账期月">{{ detail.carrier_month }}</a-descriptions-item>
        <a-descriptions-item label="套餐">{{ detail.carrier_product_name }}</a-descriptions-item>
        <a-descriptions-item label="合计">{{ detail.cost_amount }}</a-descriptions-item>
      </a-descriptions>
      <a-table
        :columns="lineColumns"
        :data-source="detail.lines || []"
        :pagination="false"
        row-key="id"
        size="small"
      />
    </a-modal>
  </div>
</template>

<script>
import { findSimCardMonthCosts, findSimCardMonthCostDetail, rerunSimCardMonthCost } from '@/api/sim_card_month_cost'
import { hasPermission } from '@/utils/permission'

export default {
  name: 'SimCardMonthCosts',
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      tableData: [],
      query: {},
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `共 ${total} 条`
      },
      columns: [
        { title: '账期月', dataIndex: 'carrier_month' },
        { title: 'ICCID', dataIndex: 'iccid' },
        { title: '号码', dataIndex: 'phone_number' },
        { title: '运营商套餐', dataIndex: 'carrier_product_name' },
        { title: '客户', dataIndex: 'agent_name' },
        { title: '来源', dataIndex: 'source_display' },
        { title: '成本合计', dataIndex: 'cost_amount' },
        { title: '操作', scopedSlots: { customRender: 'action' }}
      ],
      lineColumns: [
        { title: '分项', dataIndex: 'formula_display' },
        { title: '计量', dataIndex: 'meter' },
        { title: '用量', dataIndex: 'quantity' },
        { title: '单价', dataIndex: 'unit_price' },
        { title: '金额', dataIndex: 'cost_amount' }
      ],
      detailVisible: false,
      detail: {}
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },
    fetchData() {
      this.loading = true
      const params = Object.assign({}, this.query, {
        page: this.pagination.current,
        per_page: this.pagination.pageSize
      })
      findSimCardMonthCosts(params).then((res) => {
        this.tableData = res.data || []
        if (res.pagination) {
          this.pagination.total = res.pagination.total_count || res.pagination.total || 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleSearch(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.query = values
          this.pagination.current = 1
          this.fetchData()
        }
      })
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.fetchData()
    },
    showDetail(record) {
      findSimCardMonthCostDetail(record.id).then((res) => {
        this.detail = res.data || {}
        this.detailVisible = true
      })
    },
    handleRerun() {
      const that = this
      this.$confirm({
        title: '确认重跑上月全部运营商账期成本？',
        onOk() {
          return rerunSimCardMonthCost({}).then((res) => {
            that.$message.success(res.message || '已触发')
            that.fetchData()
          })
        }
      })
    }
  }
}
</script>
